import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Toll({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Toll</title>
      <path
        d="M4 20L21 20"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12L12 12"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 5C6 4.44772 6.44772 4 7 4H11C11.5523 4 12 4.44772 12 5V20H6V5Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 12C20.5523 12 21 12.4477 21 13V15C21 15.5523 20.5523 16 20 16H12V12H20Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4 11.55C17.6485 11.2186 18.1186 11.1515 18.45 11.4C18.7814 11.6485 18.8485 12.1186 18.6 12.45L17.4 11.55ZM15.6 16.45C15.3515 16.7814 14.8814 16.8485 14.55 16.6C14.2186 16.3515 14.1515 15.8814 14.4 15.55L15.6 16.45ZM18.6 12.45L15.6 16.45L14.4 15.55L17.4 11.55L18.6 12.45Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
